import { createLogger } from "@/infrastructure/services/logger";

/** Log client errors: console in non-PROD (via ConsoleAdapter), Sentry when configured. */
export function reportClientError(error: unknown, context = "client"): void {
  const logger = createLogger(context);
  logger.error(context, error);
}
